import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionStatesStepperComponent } from './transaction-states-stepper.component';
import { TranslateModule } from '@ngx-translate/core';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';
import { PipesModule } from '@app/core/pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
    declarations: [TransactionStatesStepperComponent],
    exports: [TransactionStatesStepperComponent],
    imports: [CommonModule, TranslateModule, SystemIconModule, PipesModule, MatIconModule, MatTooltipModule]
})
export class TransactionStatesStepperModule {}
